"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.simplifyIndiciesExpression = void 0;
function simplifyIndiciesExpression({ type = 'multi', letter = 'a', index1, index2 }) {
    let longMulti;
    let longDividend;
    let longDivisor;
    let powerExpanded;
    let simplifiedAns;
    switch (type) {
        case 'multi': {
            longMulti = '';
            for (let j = 0; j < (index1 + index2); j++) {
                if (j > 0)
                    longMulti += '\\times ';
                if (j === 0)
                    longMulti += '(';
                if (j === index1)
                    longMulti += '(';
                longMulti += `${letter} `;
                if (j === index1 - 1)
                    longMulti += ')';
                if (j === index1 + index2 - 1)
                    longMulti += ')';
            }
            break;
        }
        case 'div': {
            longDividend = '';
            for (let j = 0; j < index1; j++) {
                if (j > 0)
                    longDividend += '\\times ';
                longDividend += `${letter} `;
            }
            longDivisor = '';
            for (let j = 0; j < index2; j++) {
                if (j > 0)
                    longDivisor += '\\times ';
                longDivisor += `${letter} `;
            }
            simplifiedAns = '';
            if (index1 > index2) {
                for (let j = 0; j < (index1 - index2); j++) {
                    if (j > 0)
                        simplifiedAns += '\\times ';
                    simplifiedAns += `${letter} `;
                }
            }
            if (index1 < index2) {
                for (let j = 0; j < (index2 - index1); j++) {
                    if (j === 0)
                        simplifiedAns += '\\frac{1}{';
                    if (j > 0)
                        simplifiedAns += '\\times ';
                    simplifiedAns += `${letter} `;
                    if (j === (index2 - index1 - 1))
                        simplifiedAns += '}';
                }
            }
            if (index1 === index2)
                simplifiedAns = '1';
            break;
        }
        case 'power': {
            powerExpanded = '';
            simplifiedAns = '';
            for (let j = 0; j < index2; j++) {
                if (j > 0) {
                    powerExpanded += '\\times ';
                    simplifiedAns += '+ ';
                }
                powerExpanded += `${letter}^${index1}`;
                simplifiedAns += `${index1}`;
            }
            break;
        }
    }
    return {
        longMulti,
        longDividend,
        longDivisor,
        powerExpanded,
        simplifiedAns,
    };
}
exports.simplifyIndiciesExpression = simplifyIndiciesExpression;
